import { combineReducers } from "redux"
import customizer from "./customizer/"
import auth from "./auth/"
import navbar from "./navbar/Index"
import calenderReducer from "./calendar";
import solicitudesReducer from "./solicitudes";

const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  //solicitudes: solicitudesReducer,
  navbar: navbar,
  calendar: calenderReducer,

})

export default rootReducer
